import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

import * as Contact from '@/components/svgr/contact'
import { ContactAddress } from '@/constants/manifast'

import { Flex } from '../common/Box'
import { Tooltip, TooltipContent, TooltipTrigger } from '../ui/tooltip'

const Contacts: React.FC = () => {
  const { t } = useTranslation()

  const renderContacts = useCallback(
    () =>
      [
        {
          name: 'x',
          icon: Contact.Twitter,
          href: ContactAddress.Twitter
        },
        {
          name: 'telegram',
          icon: Contact.Telegram,
          href: ContactAddress.Telegram
        },
        {
          name: 'gitbook',
          icon: Contact.Gitbook,
          href: ContactAddress.Gitbook,
          tooltip: t('contacts.gitbook.howItWorks')
        },
        {
          name: 'dev',
          icon: Contact.Dev,
          href: ContactAddress.DevDocs,
          tooltip: t('contacts.developerDocs')
        }
      ].map(({ name, href, tooltip, icon: Icon }) => {
        const link = (
          <NavLink
            key={name}
            to={href}
            target="_blank"
            // title={tooltip ? undefined : 'how it works - gitbook'}
          >
            <Icon className="size-8 xl:size-6" />
          </NavLink>
        )
        if (!tooltip) return link

        return (
          <Tooltip key={name}>
            <TooltipTrigger>{link}</TooltipTrigger>
            <TooltipContent className="rounded-sm border bg-secondary p-1 text-xs">
              {tooltip}
            </TooltipContent>
          </Tooltip>
        )
      }),
    [t]
  )
  return (
    <Flex className="justify-center gap-16 py-4 xl:justify-start xl:gap-2 xl:py-0">
      {renderContacts()}
    </Flex>
  )
}

export default Contacts
